import Env from '../base/env';
import Channels from '../base/channels';
import Component from 'gia/Component';
import gsap from 'gsap'
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
import { SplitText } from "../vendor/gsap-bonus-umd/SplitText";
gsap.registerPlugin(ScrollTrigger,SplitText);


export default class Footer extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.reveals = this.DOM.view.querySelectorAll('.fxReveal')
   //? Fns
   this.preventLangnavClick()
   setTimeout(() => {
    this._fx()
  }, Env.timingDelayFx);
   this.fnGridUpdate = this.update.bind(this)
   Channels.on('grid::update',this.fnGridUpdate)
   //
  }

  _fx()
  {
    this.animate()
    this.reveal()
  }

  animate()
  {
    this.animation = gsap.timeline()

    this.animation
    .add([
      gsap.fromTo(
        this.DOM.reveals,
        {
          autoAlpha:0,
          y:20
        },
        {
          autoAlpha:1,
          y:0,
          ease:'quint.out',
          duration:.8,
          stagger:.25
        }
      ),
    ])

  }

  preventLangnavClick()
  {
    this.element.querySelector('.js-wpml-ls-item-toggle').addEventListener('click',(e)=>{
      e.stopImmediatePropagation()
      e.preventDefault();
      return false;
    })
  }

  reveal()
  {
    this.st = ScrollTrigger.create({
      animation:this.animation,
      trigger:this.DOM.view,
      start:'top 80%',
    })
  }

  update()
  {
    this.st.refresh()
  }

  unmount()
  {
    Channels.removeListener('grid::update',this.fnGridUpdate)
  }
}
